import {ActionPermission, Permission} from '../../types';

export const companyLevelPermission: ActionPermission = {
  permissionName: Permission.Company,
  featureName: 'company-level filters',
  location: 'connection company filters',
};
